import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "video-container"
};
const _hoisted_2 = ["src"];
import { ref, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['close'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const videoUrl = ref('');
    const isVisible = ref(false);
    const openDialog = val => {
      videoUrl.value = val;
      isVisible.value = true;
    };
    const handleVideoEnd = () => {
      isVisible.value = false;
    };
    // Expose the openDialog method
    __expose({
      openDialog
    });
    const handleClose = () => {
      isVisible.value = false;
    };
    watch(isVisible, newValue => {
      if (!newValue) {
        emit('close');
      }
    });
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: isVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isVisible.value = $event),
        onClose: handleClose,
        style: {
          "background-color": "#151b49",
          "color": "#fff"
        }
      }, {
        title: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("h2", null, "视频介绍", -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [isVisible.value ? (_openBlock(), _createElementBlock("video", {
          key: 0,
          controls: "",
          autoplay: "",
          onEnded: handleVideoEnd,
          src: videoUrl.value,
          class: "video-player"
        }, null, 40, _hoisted_2)) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});